// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__3-2ck","green":"Badge_green__CLxJA","blue":"Badge_blue__ZVpir","orange":"Badge_orange__VAVcR","noBorder":"Badge_noBorder__3O2E7","brown":"Badge_brown__76kOz"};